import { useState, useEffect } from 'react';
import { PixelRatio } from 'react-native';
export const usePixelRatio = ({ step, max, grow } = {}) => {
    const currentRatio = PixelRatio.get();
    const [deviceRatio, setDeviceRatio] = useState(currentRatio);
    useEffect(() => {
        if (grow) {
            setDeviceRatio((prev) => (currentRatio > prev ? currentRatio : prev));
        }
    }, [grow, setDeviceRatio, currentRatio]);
    let ratio = deviceRatio;
    if (step) {
        ratio = Math.max(step * Math.round(ratio / step), step);
    }
    if (max) {
        ratio = max ? Math.min(ratio, max) : ratio;
    }
    return ratio;
};
//# sourceMappingURL=usePixelRatio.js.map